package io.horion.cv.api.datasource.response

import kotlinx.serialization.Serializable

@Serializable
data class SessionsResponse(
    val success : Boolean,
    val status : PaymentStatus = PaymentStatus.PENDING ,
    val message : String
)